module.exports = __webpack_public_path__ + "static/img/WyPavel.9fe65bb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/card/WyPavel.jpg
// module id = /h2O
// module chunks = 1